import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ButtonModule
  ],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.css'
})
export class LandingComponent {
  featuredStores = [
    {
      name: 'Tech Store',
      category: 'Electronics',
      image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400&h=300&fit=crop',
      description: 'Latest gadgets and electronics'
    },
    {
      name: 'Fashion Hub',
      category: 'Fashion & Apparel',
      image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=400&h=300&fit=crop',
      description: 'Trendy fashion and accessories'
    },
    {
      name: 'Home Essentials',
      category: 'Home & Garden',
      image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=300&fit=crop',
      description: 'Everything for your home'
    }
  ];

  features = [
    {
      icon: 'pi-shopping-bag',
      title: 'Shop from Multiple Stores',
      description: 'Browse and purchase from thousands of trusted merchants in one place'
    },
    {
      icon: 'pi-shield',
      title: 'Secure Payments',
      description: 'Your transactions are protected with industry-leading security'
    },
    {
      icon: 'pi-truck',
      title: 'Fast Delivery',
      description: 'Get your orders delivered quickly and safely to your doorstep'
    },
    {
      icon: 'pi-heart',
      title: 'Wishlist & Favorites',
      description: 'Save your favorite products and stores for easy access later'
    }
  ];

  stats = [
    { number: '10K+', label: 'Active Stores' },
    { number: '500K+', label: 'Happy Customers' },
    { number: '1M+', label: 'Products Available' },
    { number: '99%', label: 'Satisfaction Rate' }
  ];

  testimonials = [
    {
      name: 'Sarah Johnson',
      role: 'Frequent Shopper',
      image: 'https://i.pravatar.cc/150?img=1',
      text: 'ArkifiHub has made shopping so convenient! I can find everything I need from different stores in one place.'
    },
    {
      name: 'Michael Chen',
      role: 'Business Owner',
      image: 'https://i.pravatar.cc/150?img=2',
      text: 'As a store owner, ArkifiHub has helped me reach more customers and grow my business significantly.'
    },
    {
      name: 'Emily Rodriguez',
      role: 'Fashion Enthusiast',
      image: 'https://i.pravatar.cc/150?img=3',
      text: 'The variety of stores and products is amazing. I love how easy it is to discover new brands!'
    }
  ];

  constructor(
    private router: Router
  ) {}

  goToMarketplace(): void {
    this.router.navigate(['/marketplace']);
  }

  goToStore(storeName: string): void {
    // This would navigate to a specific store if we had the ID
    this.router.navigate(['/marketplace']);
  }

  goToCreateStore(): void {
    // Open the store creation URL in a new tab
    window.open('https://business.arkifi.store/', '_blank');
  }
}
